import { render, staticRenderFns } from "./aliBillDetail.vue?vue&type=template&id=74ec9735&"
import script from "./aliBillDetail.vue?vue&type=script&lang=js&"
export * from "./aliBillDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports